import React, {useEffect} from 'react';
import { Stage, Layer, Rect, Line } from 'react-konva';
import CellTemplateGrid from './CellTemplateGrid';

function CellTemplateMaker({ width, height, onStageClick, children, ghostChildren, backgroundColor = "white", onBackgroundColorChange, onShapesLayerReady, scale = 1, showCenterGuides = false, cellBorderColor, cellBorderWidth = 0, cellBorderRadius = 0, cellPadding = 0 }) {


  let shapesLayer = React.createRef();  // Create a reference to the shapes layer

  useEffect(() => {
      // Pass the shapesLayer to the parent when it's ready
      if (shapesLayer.current) {
          onShapesLayerReady(shapesLayer.current);
      }
  }, [shapesLayer, onShapesLayerReady]);



  const handleStageMouseDown = e => {
    if (e.target === e.target.getStage()) {
      onStageClick();
    }
  };

  const handleStageRightClick = e => {
    e.evt.preventDefault();
    if (e.target === e.target.getStage()) {
      const newColor = window.prompt('Please enter a color for the base rectangle:', backgroundColor);
      if (newColor) {
        onBackgroundColorChange(newColor); // Use the function passed as a prop
      }
    }
  };


  return (
    <div className="cell-template-maker">
    <Stage
      width={width * scale}
      height={height * scale}
      scaleX={scale}
      scaleY={scale}
      onMouseDown={handleStageMouseDown}
      onTouchStart={handleStageMouseDown}
      onContextMenu={handleStageRightClick}
    >
      <Layer>
        <Rect
          id="template-background"
          width={width}
          height={height}
          fill={backgroundColor}
          cornerRadius={cellBorderRadius}
          listening={false}
        />
        {cellBorderWidth > 0 && cellBorderColor && (
          <Rect
            x={0}
            y={0}
            width={width}
            height={height}
            stroke={cellBorderColor}
            strokeWidth={cellBorderWidth}
            cornerRadius={cellBorderRadius}
            listening={false}
          />
        )}
        {cellPadding > 0 && (
          <Rect
            x={cellPadding}
            y={cellPadding}
            width={width - cellPadding * 2}
            height={height - cellPadding * 2}
            stroke="#e5e7eb"
            strokeWidth={0.5}
            dash={[4, 4]}
            listening={false}
          />
        )}
        <CellTemplateGrid width={width} height={height} gap={8} />
      </Layer>
      {ghostChildren && (
        <Layer listening={false} opacity={0.35}>
          {ghostChildren}
        </Layer>
      )}
      <Layer ref={shapesLayer}>
        {children}
      </Layer>
      {showCenterGuides && (
        <Layer listening={false}>
          {/* Vertical center line */}
          <Line
            points={[width / 2, 0, width / 2, height]}
            stroke="#ff8264"
            strokeWidth={1.5}
            dash={[6, 4]}
            listening={false}
          />
          {/* Horizontal center line */}
          <Line
            points={[0, height / 2, width, height / 2]}
            stroke="#ff8264"
            strokeWidth={1.5}
            dash={[6, 4]}
            listening={false}
          />
        </Layer>
      )}
    </Stage>
    </div>
  );
}

export default CellTemplateMaker;
